import type { FaireBrandEntity } from "../../entity_types/brand";

const AVATAR =
  "https://cdn.faire.com/fastly/a761694a2058b551ddf35ca17854f60089e52d1ebecba58fa444257dab393cd2.jpeg?dpr=2&fit=crop&format=jpg&height=192&width=192";

/** Wide hero — local asset (two models / Ceremonia campaign). */
const BANNER =
  "https://cdn.prerelease.faire.dev/fastly/7c40ba5f8852f532b554a026016b222eca0a6521d9f9ec420d2ecadd7881202f.jpeg";

export const b_4240zqg5kc: FaireBrandEntity = {
  token: "b_4240zqg5kc",
  type: "brand",
  name: "Ceremonia",
  avatarUrl: AVATAR,
  logoUrl: AVATAR,
  bannerUrl: BANNER,
  heroImageUrl: BANNER,
  location: "New York, New York, US",
  minimumOrderDollars: 300,
  rating: 4.8,
  reviewCount: 214,
  productCount: 51,
  description:
    "Ceremonia is a clean hair care brand with clinically-backed results and ingredients rooted in Latin heritage. We are on a mission to empower a confident natural that feels as good as it looks, manifesting modern-day rituals that feed your hair from the roots and beyond, because hair wellness is the key to unlocking the best hair days.",
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
};
